// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1saSj","tabsBox":"styles_tabsBox__3Ov4M","createButton":"styles_createButton__363LD"};